<template>
  <div v-if="sign && !signed">
    <!-- Modal -->
    <div
      class="modal fade"
      id="signContract"
      tabindex="-1"
      role="dialog"
      aria-labelledby="signContractLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="signContractLabel">Sign Contract</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="saving = false"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-6">
                <div class="name">
                  <div class="form-group mb-3">
                    <TextInput
                      v-model="form.name"
                      :errors="errors.name"
                      label="Full Name"
                      autofocus
                      autocapitalize="off"
                      name="name"
                      validateSuccess
                      validateError
                    />
                  </div>

                  <div class="form-group mb-3">
                    <TextInput
                      v-model="form.email"
                      :errors="errors.email"
                      type="email"
                      label="Business Email Address"
                      autocapitalize="off"
                      name="email"
                      validateSuccess
                      validateError
                    />
                  </div>

                  <div class="form-group">
                    <TextInput
                      v-model="form.job_title"
                      :errors="errors.job_title"
                      label="Job Title"
                      autocapitalize="off"
                      name="job_title"
                      validateSuccess
                      validateError
                    />
                  </div>
                </div>

                <small>
                  <p>By clicking "Sign Contract",  I acknowledge and agree that an electronic signature will be added to this document which is a digital representation of my signature, having the same legally-binding effect as a ‘wet’ (pen-on-paper) signature.</p>
                  <p>Further, I warrant, represent and undertake:</p>
                  <ol>
                    <li>that I am a duly-authorised signatory of the above-named Party;</li>
                    <li>that I have the capacity to commit my organisation to this legally-binding document; and</li>
                    <li>to the Agreement Provider Group that my organisation has received independent professional advice as to the legal effect of this document.</li>
                  </ol>
                </small>

              </div>
              <div class="col-lg-6">
                <Signature :signature="form" :header="true" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="saving = false" type="button" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
            <form @submit.prevent="submit">
              <button type="submit" class="btn btn-primary">
                Sign Contract
              </button>
              <!-- <LoadingButton :loading="saving" class="btn btn-primary" type="submit">
                Sign Contract
              </LoadingButton> -->
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Button trigger modal -->
    <div class="container">
      <div class="row">
        <div class="col-md-4 offset-md-4">
          <button
            type="button"
            class="btn btn-block btn-primary mb-2"
            data-toggle="modal"
            data-target="#signContract"
          >
            Sign Contract
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from './Mixin';
import TextInput from '@/Shared/Inputs/Text';
import LoadingButton from '@/Shared/LoadingButton';
import Signature from '@/Pages/Asset/Contract/Signatures/Signature';

export default {
  mixins: [Mixin],

  components: {
    TextInput,
    LoadingButton,
    Signature,
  },

  data() {
    return {
      errors: {},
      saving: false,
      form: {
        name: this.$page.props.auth.user.type === 'clausify'
          ? `${this.$page.props.auth.user.first_name} ${this.$page.props.auth.user.last_name}`
          : null,
        email: this.$page.props.auth.user.type === 'clausify'
          ? this.$page.props.auth.user.email
          : null,
        job_title: null,
        behalfable: {
          name: this.$page.props.auth.user.type === 'clausify'
            ? this.$page.props.auth.user.organisation.name
            : this.$page.props.auth.user.counterparty,
        },
      },
      signed: false,
    };
  },

  computed: {
    sign() {
      this.areAllActionsAccepted();

      if (this.state.withCounterparty) {
        const showForStates = [
          'editing',
          'pending',
          'approved',
        ];

        if (showForStates.includes(this.state.state)) {
          if (this.userHasType('clausify')) {
            return this.allActionsAccepted && this.userHasPermissionTo('sign_contract');
          }
          return this.allActionsAccepted;
        }
      }

      if (!this.state.withCounterparty) {

        const showForStates = [
          'signed',
        ];

        if (showForStates.includes(this.state.state)) {
          return this.allActionsAccepted && this.userHasPermissionTo('sign_contract');
        }
      }

      return false;
    },
  },

  methods: {
    submit() {
      this.saving = true;
      window.axios
        .post(`/asset/${this.asset}/sign`, this.form)
        .then(({ data }) => {
          $('#signContract').modal('hide');
          this.$inertia.visit(data);
        })
        .catch((error) => {
          this.saving = false;
          this.errors = error.response.data.errors;
        });
    },
  },

};
</script>
